import { transform } from 'lodash';

// オブジェクトの値の型を再帰的に定義
type DeepMappedValue =
  | string
  | number
  | boolean
  | null
  | undefined
  | DeepMappedObject;

type DeepMappedObject = {
  [key: string]: DeepMappedValue;
};

// より安全な型定義でObjectのチェックを行う
function isObject(value: unknown): value is Record<string, unknown> {
  return value instanceof Object;
}

export function deepMapKeys(
  obj: Record<string, unknown>,
  mapFunc: (key: string) => string,
): DeepMappedObject {
  return transform(obj, (r: DeepMappedObject, v, k: string) => {
    r[mapFunc(k)] = isObject(v)
      ? deepMapKeys(v, mapFunc)
      : (v as DeepMappedValue);
  });
}

export function delimited(n: string | number | string[] | undefined): string {
  if (n == null) {
    return '';
  }

  if (typeof n === 'string') {
    const checkedNumberStr = n.replace(/[^0-9.]/g, '');
    if (checkedNumberStr === '') {
      return '';
    }
    n = parseInt(checkedNumberStr, 10);
  }

  return String(n).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
}

export function numberToCurrency(n: number | null): string {
  if (n == null) {
    return '0円';
  }
  return delimited(n) + '円';
}
